import { Component } from '@angular/core';

@Component({
  selector: 'app-pie-chart',
  template: '<app-chart-output></app-chart-output>',
  
})
export class PieChartComponent {

}
